<template>
  <b-dropdown
    ref="dropdown"
    :class="$style.dropdown"
    manual
  >
    <template #toggle>
      <b-button-legacy
        :type="type"
        :theme="theme"
        :width="btnWidth && btnWidth"
        :icon-left="btnIconLeft"
        :size="btnSize"
        :class="$style.button"
        @click="openSelect"
      >
        <span :class="$style.buttonText">
          <template v-if="selectedOption.label">
            {{ selectedOption.label }}
          </template>
          <template v-else>
            {{ placeholder }}
          </template>
        </span>
        <b-svg
          :class="$style.icon"
          v-if="!isOpened"
          name="arrow-down"
          :height="iconSize"
        />
        <b-svg
          :class="$style.icon"
          v-else name="arrow-down"
          :height="iconSize"
          rotate="180"
        />
      </b-button-legacy>
    </template>

    <b-list
      :items="options"
      :class="$style.list"
    >
      <template v-slot:item="{ item, index }">
        <b-list-item
          @click="selectItem(item)"
          :item="{
            name: item.label,
            selected: index === selectedIndex
          }"
        >
        </b-list-item>
      </template>
    </b-list>
  </b-dropdown>
</template>

<script>
import { find, findIndex, propEq } from 'ramda'

export default {

  emits: [
    'input',
  ],
  props: {
    value: undefined,
    type: {
      type: String,
      default: 'button',
    },
    theme: {
      type: String,
      default: 'secondary',
    },
    placeholder: {
      type: String,
      required: false,
      default: 'Select value',
    },
    options: {
      type: Array,
      required: true,
    },
    btnSize: {
      type: String,
      default: '',
    },
    btnWidth: {
      type: String,
      default: '',
    },
    btnIconLeft: {
      type: Object,
      default: null,
    },
    styleType: {
      type: String,
      default: '',
    },
    iconSize: {
      type: String,
      defalut: '24px',
    },
  },

  computed: {
    selectedOption () {
      let o = find(propEq('value', this.value))(this.options)
      return o || {
        label: this.value,
        value: this.value,
      }
    },

    selectedIndex () {
      return findIndex(propEq('value', this.value))(this.options)
    },

    isOpened () {
      return this.$refs.dropdown && this.$refs.dropdown.opened
    },
  },

  methods: {
    openSelect () {
      this.$refs.dropdown.open()
    },
    selectItem (item) {
      this.$emit('input', item.value)
      this.$refs.dropdown.close()
    },
  },
}
</script>

<style lang="scss" module>
.dropdown .button {
  border-radius: 6px;
}
.buttonText {
  flex: 1;
  padding: 0 4px;
  text-align: left;
  text-transform: capitalize
}
.list li {
  border-bottom: 1px solid $color-gray-14;

  &:last-child {
    border: 0;
  }
}
</style>
